<div *ngIf="isBrowser && (authService.isUserLoggedIn() | async) === false">
  <div
    [attr.data-cy]="'user-menu-login'"
    (click)="loginLogoutRequest()"
    (keydown)="onKeyDown($event, loginAction)"
    [class.active]="highlighted"
    class="highlightable-header-tab py-4 ms-4 ms-md-5 d-flex justify-content-center flex-column p-1 p-sm-0">
    <div class="d-flex align-items-center">
      <span
        [tabIndex]="0" role="link" title="{{ 'userMenu.account' | cxTranslate }}"
        class="highlightable-header-tab__text ds-icon--account ds-icon--big focusable focusable__element">
      </span>
    </div>
  </div>
</div>
<div #ngbDropdown
     (openChange)="dropDownOpenAction($event)"
     *ngIf="(authService.isUserLoggedIn() | async) === true"
     autoClose="outside"
     display="dynamic"
     ngbDropdown
     placement="bottom-center bottom-end bottom-start">
  <div (keydown)="onKeyDown($event, dropdownOpenAction)"
       [class.active]="highlighted"
       class="highlightable-header-tab py-4 ms-4 ms-md-5 d-flex justify-content-center flex-column"
       data-cy="user-menu-toggle"
       ngbDropdownToggle>
    <div [tabIndex]="0"
         class="d-flex align-items-center focusable-round p-1" data-cy="user-menu-user-icon"
         role="button" title="{{ 'userMenu.accountMenu' | cxTranslate }}"
         [attr.aria-label]="'userMenu.accountMenu' | cxTranslate"
         aria-expanded="false">
      <span class="highlightable-header-tab__text ds-profile-placeholder ds-icon--big"></span>
    </div>
  </div>
  <div #userMenuDropdown class="user-menu--dropdown" ngbDropdownMenu>
    <div class="d-flex flex-column justify-content-center align-items-stretch">
      <ng-container *ngIf="userToken$ | async as userToken">
        <div *ngIf="user$ | async as user">
          <div class="mt-4 mb-3">
            <dcp-user-info [user]="user" class="mx-0 mx-sm-4 mb-3 mb-sm-2"></dcp-user-info>
            <dcp-user-menu-links [dropdown]="dropdown"></dcp-user-menu-links>
          </div>
          <hr class="m-0">
        </div>
        <div class="d-flex justify-content-center m-4" data-cy="user-menu-login">
          <button (click)="loginLogoutRequest()" class="btn btn-outline-primary" type="button">
            {{(userToken.access_token ? 'userMenu.logout' : 'userMenu.login') | cxTranslate}}
          </button>
        </div>
      </ng-container>
    </div>
  </div>
</div>
